module.exports = __webpack_public_path__ + "static/media/sensor-alert.b16b4420.svg";